import React, { Component } from 'react';

import smile from './images/emoticon-smile.svg';
import unsure from './images/emoticon-unsure.svg';

class Emoticon extends Component {
	constructor() {
		super();
		this.state = {
			clicked: false,
			emoticon: smile
		}
	}

	onClick() {
		if (!this.state.clicked) {
			this.setState({
				clicked: true,
				emoticon: unsure
			});
			setTimeout(() => {
				this.setState({
					clicked: false,
					emoticon: smile
				});
			}, 2000);
		}
	}

	render() {
		return (
			<div className='row' style={styles.container}>
				<div className='col-xs-12'>
					<img
						src={this.state.emoticon}
						style={styles.emoticon}
						alt='emoticon'
						onClick={this.onClick.bind(this)}
					/>
					<span style={styles.clickMe}>click me</span>
				</div>
			</div>
		)
	}
}

export default Emoticon;

const styles = {
	container: {
		margin: '10px 0px 30px 0px'
	},
	emoticon: {
		display: 'block',
		maxWidth: 300,
		width: '100%',
		margin: '0px auto',
		marginTop: 20
	},
	clickMe: {
		display: 'block',
		margin: '0px auto',
		paddingTop: 3,
		textAlign: 'center',
		fontSize: '0.6em'
	}
}



// WEBPACK FOOTER //
// ./src/Emoticon.js